export default {
  name: "ReservationDataHeader",
  props: ["reservation", "companyName"]
};
